import { IconButton } from '@creditornot/cb-button';
import { Cross } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type Props = {
  className?: string;
  header: React.ReactNode;
  onClose: React.MouseEventHandler<HTMLButtonElement>;
  subheader: React.ReactNode;
};

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;
const Subheader = styled(T.Body3)`
  margin-block-start: 8px;
`;

export const ModalHeaderWithSubheader = ({ className, onClose, header, subheader }: Props) => (
  <Root className={className}>
    <Left>
      <T.Heading6>{header}</T.Heading6>
      <Subheader>{subheader}</Subheader>
    </Left>

    <IconButton size="small" background="static" variant="grey" alignment="boundingBox" onClick={onClose}>
      <Cross />
    </IconButton>
  </Root>
);
